import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ComponentsModule } from '@app/components/components.module';
import { TranslateModule } from '@ngx-translate/core';

import { ObservationsCardComponent } from './observations-card/observations-card.component';

const components = [ObservationsCardComponent];

@NgModule({
  declarations: components,
  imports: [CommonModule, FormsModule, TranslateModule.forChild(), ComponentsModule],
  exports: components
})
export class ManageVacationsSharedModule {}
